module.exports = __webpack_public_path__ + "img/icon_shuaxin.ddf9d0c9.svg";